import Utilisateur from "../../Models/Utilisateur";
import ParamsPicklist from "../../Types/ParamsPicklist";
import Data from "../../Data/Data.json";
import { Crypter } from "../Security/Crypter";
import axios from "axios";
import SweetAlert from "sweetalert2";
import { BilletageOperation } from "../../Models/BilletageOperation";

export function LoadBilletage(props: {
  Table: string;
  ColRef: string;
  Ref: string;
  authHeader : any,
  user: Utilisateur
  form: any;
  onDouble?: boolean
}) {

  let search: ParamsPicklist = {
    CodeAgence: props.user.codage,
    Table: props.Table,
    Colonne1: props.ColRef,
    Colonne2: "",
    Colagence: "101",
    Init: props.Ref,
    Choix: 35,
  };

  let config: any = {
    method: "get",
    maxBodyLength: Infinity,
    url: Data.ApiUrl.AnySearch,
    headers: {
      CypherSearch: Crypter.encrypt(JSON.stringify(search)),
      Authorization: props.authHeader,
      "Content-Type": "application/json",
    },
  };
  axios
    .request(config)
    .then((response) => {
      if (response.data) {
        const res = JSON.parse(Crypter.decrypt(response.data)).Value;
        console.log(res);

        if (res.StatutCode == 200) {
          // alert(JSON.stringify(res.Result))
          var billetages: BilletageOperation[] = res.Result.Table;
          billetages.map((b: BilletageOperation) => {
            props.form.setFieldValue((props.onDouble? "D_": "")+((b as any).CodeBilletage), (((b as any).Quantite) as number));
          });
          props.form.setFieldValue("Billetages", billetages)
        } else {
          SweetAlert.fire({
            title: "Attention",
            icon: "warning",
            text: res.Message,
          });
        }
      } else {
        SweetAlert.fire({
          title: "Erreur",
          icon: "error",
          text: "Erreur de chargement du billetage",
        });
      }
    })
    .catch((error) => {
      SweetAlert.fire({ title: error, icon: "error" });
    });
}
